module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA6.ba251523.jpg";